const UserContactSupportValues = (showData = null) => {
  const data = showData?.data || showData;
  return {
    assigned_to_id: data?.assigned_to_id || "",
    admin_comment: data?.admin_comment || "",
  };
};

export default UserContactSupportValues;
